import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export interface RenameDialogProps {
  open: boolean;
  title?: string;
  label?: string;
  currentName: string;
  onClose: () => void;
  onConfirm: (newName: string) => void | Promise<void>;
  loading?: boolean;
}

export const RenameDialog: React.FC<RenameDialogProps> = ({
  open,
  title = "Rinomina",
  label = "Nome",
  currentName,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const [newName, setNewName] = React.useState(currentName);

  React.useEffect(() => {
    if (open) {
      setNewName(currentName);
    }
  }, [open, currentName]);

  const handleConfirm = async () => {
    if (newName.trim() && newName.trim() !== currentName) {
      await onConfirm(newName.trim());
    }
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={label}
          fullWidth
          variant="outlined"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Annulla
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={
            loading || !newName.trim() || newName.trim() === currentName
          }
        >
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
};
